import React, { useEffect, useState } from "react";
import DepartmentForm from "./departmentform";
import axiosInstance from "../services/axiosInstance";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import WorkflowSheet from "./workflowSheet";
import JobSheet from "./jobSheet";
import WorkflowPopUp from "../Popup/workflowPopup";
import DeleteOrderPopup from "../Popup/deleteOrderPopup";
import JobSheetV2 from "./JobSheetV2";
import JobSheetInvoicePage from "./JobSheetInvoicePage";

const cardStyle = {
  boxShadow: "0px 0px 8px rgba(44, 99, 152, 0.12)",
};

const formatDueDeliveryDate = (dueDeliveryDate) => {
  if (!dueDeliveryDate) return "";

  const date = new Date(dueDeliveryDate);

  // Extract day, month, hours, and minutes
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  // Format as dd.MM | HH:mm
  return `${day}.${month} | ${hours}:${minutes}`;
};

const WorkflowPlanOrder = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopup2, setOpenPopup2] = useState(false);
  const [formData, setFormData] = useState([]);
  const [orderId, setOrderId] = useState(null);
  const [orderStatusId, setOrderStatusId] = useState(null);
  const [wfSheetData, setWfSheetData] = useState({
    patientName: "",
    dentistName: "",
    geoCode: "",
    workTypeDescription: "",
    departments: [],
  });
  const [jobSheetData, setJobSheetData] = useState({
    patientName: "",
    dentistName: "",
    standard_Notes: "",
    individual_Notes: "",
    workType: "",
    workTypeDescription: "",
    invoiceInformationDetails: [],
  });
  const [teethPositions, setTeethPositions] = useState([]);

  const HandleRemovePopUp = () => setOpenPopup(false);
  const HandleDeletePopUp = () => setOpenPopup2(false);

  const option1 = {
    method: "open",
    resolution: Resolution.NORMAL,
    page: {
      margin: Margin.SMALL,
      format: "A6",
      orientation: "landscape",
    },
    canvas: { mimeType: "image/png", qualityRatio: 1 },
    overrides: { canvas: { useCORS: true } },
  };

  const option2 = {
    method: "open",
    resolution: Resolution.HIGH,
    page: {
      margin: Margin.SMALL,
      format: "A4",
      orientation: "portrait",
    },
    canvas: { mimeType: "image/png", qualityRatio: 1 },
    overrides: { canvas: { useCORS: true } },
  };

  const getTargetElement1 = () => document.getElementById("work-flow-sheet");
  const getTargetElement2 = () =>
    document.getElementById("job-sheet-pdf-wrapper");

  const twohandleClick = () => {
    setOpenPopup(true);
    setIsVisible(true);
    handleGeneratePDF1();
  };

  const handleGeneratePDF1 = () => {
    setTimeout(() => {
      generatePDF(getTargetElement1, option1); // Generate PDF for work-flow-sheet
      handleGeneratePDF2();
    }, 500);
  };

  const handleGeneratePDF2 = () => {
    setTimeout(() => {
      generatePDF(getTargetElement2, option2); // Generate PDF for job-sheet
      setIsVisible(false);
    }, 500);
  };

  const handleCreateOrder = async () => {
    if (!orderId) {
      alert("Auftrags-ID nicht auffindbar.");
      return;
    }

    if (formData.length === 0) {
      alert("Formular unvollständig.");
      return;
    }
    for (const [index, item] of formData.entries()) {
      if (item.hours === "0" || item.hours === 0) {
        alert(`Bitte Anzahl der Stunden angeben`);
        return;
      }

      if (item.departmentId == null) {
        alert(`Bitte Abteilung auswählen`);
        return;
      }
    }

    const AffectedDepartmentIds = formData.map((item, index) => ({
      DepartmentId: item.departmentId,
      Hours: parseFloat(item.hours),
      DueDateTime: item.dueDeliveryDate,
      orderWorkFlowId: item?.orderWorkFlowId,
      SequenceNo: index + 1,
    }));
    try {
      const response = await axiosInstance.post(
        "/api/order/createOrUpdateOrderWorkFlow",
        {
          WorkflowDeparmentsDtos: AffectedDepartmentIds,
          Orderid: orderId,
          OrderStatusId: orderStatusId,
          finalDueDeliveryDate: formData[formData.length - 1].dueDeliveryDate,
        }
      );
      //console.log("API Response:", response);
      if (response.isSuccess) {
        setWfSheetData({
          patientName: response.data1.patientName,
          dentistName: response.data1.dentistName,
          geoCode: response.data1.geoCode,
          workTypeDescription: response.data1.workTypeDescription,
          workTypeName: response.data1.workTypeName,
          departments: response?.data1?.departments,
        });

        setJobSheetData({
          patientName: response?.data2.patientName,
          dentistName: response?.data2.dentistName,
          standard_Notes: response?.data2.standard_Notes || "",
          individual_Notes: response?.data2.individual_Notes || "",
          workTypeDescription: response?.data2.workTypeDescription || "",
          workTypeName: response?.data2?.workTypeName || "",
          invoiceInformationDetails: response?.data2?.invoiceInformationDetails || [],
        });
        setTeethPositions(response?.data2.teethPositions);
        twohandleClick();
      } else {
        alert(
          "Bestellung konnte nicht erstellt werden. Bitte versuchen Sie es erneut."
        );
      }
    } catch (error) {
      alert("Beim Anlegen der Bestellung ist ein Fehler aufgetreten.");
    }
  };

  return (
    <div>
      <style>
        {`
          #job-sheet.hidden {
            display: none;
          }
          #work-flow-sheet.hidden {
            display: none;
          }
        `}
      </style>
      <div
        className="relative rounded-[20px] bg-blue-400 mt-5
      before:content-[''] before:bottom-0 before:left-0 before:w-[240px] before:h-full before:bg-cover before:bg-left-bottom before:bg-no-repeat before:absolute before:bg-[url('./assets/images/round_border_bg_left.svg')] before:hidden lg:before:block
      after:content-[''] after:top-0 after:right-0 after:w-[308px] after:h-full after:bg-cover after:bg-right-top after:bg-no-repeat after:absolute after:bg-[url('./assets/images/round_border_bg_right.svg')] after:hidden lg:after:block z-0
        "
        style={cardStyle}
      >
        <div className="bg-blue p-4 text-center rounded-t-[20px]">
          <h1 className="text-5xl xl:text-4xl 3xl:text-5xl text-white font-robotoBold">
            Produktionsplannung
          </h1>
        </div>
        <div className="py-14 xl:py-10 3xl:py-14">
          <DepartmentForm
            setOrderStatusId={setOrderStatusId}
            setFormData={setFormData}
            setOrderId={setOrderId}
          />
        </div>
      </div>
      <div className="pb-12 2xl:pb-0 flex items-center justify-end gap-5 mt-5 z-index: 99990">
        {/* <button className="px-5 py-2 border uppercase border-blue-500 text-blue font-robotoBold rounded-lg hover:bg-blue-800 hover:border-blue-800 hover:text-white transition duration-300"  onClick={PreviewPdf}>
            Preview PDF
        </button> */}
        <button
          className="px-5 py-2 text-2xl xl:!text-base 3xl:!text-2xl border uppercase border-blue-500 text-blue font-robotoBold rounded-lg hover:bg-blue-800 hover:border-blue-800 hover:text-white transition duration-300"
          type="button"
          onClick={() => {
            setOpenPopup2(true);
          }}
        >
          Auftrag Löschen
        </button>
        {orderStatusId != null ? (
          <button
            className="bg-blue text-2xl xl:!text-base 3xl:!text-2xl uppercase border border-blue hover:bg-blue-800 hover:border-blue-800 text-white font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in"
            type="button"
            onClick={handleCreateOrder}
          >
            Änderungen Speichern Order
          </button>
        ) : (
          <button
            className="bg-blue text-2xl xl:!text-base 3xl:!text-2xl uppercase border border-blue hover:bg-blue-800 hover:border-blue-800 text-white font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in"
            type="button"
            onClick={handleCreateOrder}
          >
            Auftrag Anlegen
          </button>
        )}
      </div>

      {/* modal popup */}
      <WorkflowPopUp openPopUp={openPopup} closePopUp={HandleRemovePopUp} />
      <DeleteOrderPopup
        openPopUp={openPopup2}
        closePopUp={HandleDeletePopUp}
        orderId={orderId}
      />

      {/* work flow sheet */}
      <WorkflowSheet
        wfSheetData={wfSheetData}
        formatDueDeliveryDate={formatDueDeliveryDate}
        isVisible={isVisible}
      />

      {/* job sheet */}
      <div
        id="job-sheet-pdf-wrapper"
        style={{
          width: "794px", // A4 width at 96 DPI
          minHeight: "1123px", // A4 height at 96 DPI
          backgroundColor: "white",
          ...(!isVisible && { display: "none" }),
        }}
      >
        {/* 1st Page */}
        <JobSheetV2
          jobSheetData={jobSheetData}
          isVisible={isVisible}
          toothGridData={teethPositions}
        />

        {/* 2nd Page */}
        {/* <JobSheetInvoicePage
          isVisible={isVisible}
          jobSheetData={jobSheetData}
        /> */}
      </div>
      {/* <JobSheet
        jobSheetData={jobSheetData}
        isVisible={isVisible}
        toothGridData={teethPositions}
      /> */}
    </div>
  );
};

export default WorkflowPlanOrder;
